import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const expensesCategoryReportWidget: DashboardWidgetConfiguration = {
  widgetId: "expenses.category-report",
  name: "Expense categories",
  description: "Expense categories using the reusable report-widget visualization.",
  apps: [
    "home",
    "expenses",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "expenses.records",
      ...period(30),
      select: [
        {
          type: "field",
          field: "category_id",
          as: "category_id",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "amount_total",
          as: "spend",
        },
      ],
      group_by: [
        {
          field: "category_id",
        },
      ],
      order_by: [
        {
          ref: "spend",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Expense categories",
    subtitle: "Live RQL report",
    output: "pie",
    visualization: "donut",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "$36,480",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
